import React from 'react'

const Contact = () => {
  return (
    <div className='Contact'>
        <main>
            <h1>Contact Us</h1>
            <form action="">
                <div>
                    <label>Name</label>
                    <input type="text" required placeholder='Enter the name' />
                </div>
                <div>
                    <label>Email</label>
                    <input type="text" required placeholder='Enter the Email' />
                </div>
                <div>
                    <label>message</label>
                    <input type="text" required placeholder='tell us about your query' />
                </div>
                <button type='submite'>submite</button>
            </form>
        </main>
    </div>
  )
}

export default Contact